import { jsx as _jsx } from "react/jsx-runtime";
export function Panel({ raised = false, className = "", children, ...rest }) {
    const raisedClass = raised ? " nbs-panel--raised" : "";
    return (_jsx("div", { className: `nbs-panel${raisedClass} ${className}`.trim(), ...rest, children: children }));
}
//# sourceMappingURL=Panel.js.map